module.exports={select:"Valitse",selected:"Valittu"};